import { Box, Button, Collapse, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, Select, Switch, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { getServicioAutSanitaria, getServiciosMed, postServicioAutSanitaria, deleteSerivioAutSanitaria } from 'services/api';
import Spinner from '@jumbo/components/custom/Spinner';
import SharedTitle from 'routes/Pages/FichasTecnicas/Components/SharedForms/SharedTitle';
import { useLocation } from 'react-router-dom';
import { formatRut, LABEL_INPUT_FONT_SIZE, ordenarArregloAlfabeticamente, tiposAux, validateRut } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import AsInstalacionFuncionamiento from 'routes/Pages/FichasTecnicas/Components/FormCapacidadInstaladaComponents/AsInstalacionFuncionamiento';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {  CheckBox, Save, Warning } from '@material-ui/icons';
import CapacidadInstaladaPropuesta from 'routes/Pages/FichasTecnicas/Components/SharedForms/CapacidadInstaladaPropuesta';


const CamasMedicina = (props) => {


    const [isLoading, setIsLoading] = useState(true)
    const [instalacionesList, setInstalacionesList] = useState([])
    const location = useLocation();
    const [titulo, setTitulo] = useState('Cargando...')
    const [descripcion, setDescripcion] = useState('')

    const [hasService, setHasService] = useState(0)
    const [aut_sanitaria, set_aut_sanitaria] = useState(0)
    const [nro_resolucion, set_nro_resolucion] = useState('')
    const [fecha_resolucion, set_fecha_resolucion] = useState('')
    const [tipo_servicio, set_tipo_servicio] = useState(0)
    const [nombre_proveedor, set_nombre_proveedor] = useState('')
    const [rut_proveedor, set_rut_proveedor] = useState('')
    const [guardar_flag, set_guardarFlag] = useState(true)
    const [flag_mostrar, set_flag_mostrar] = useState(false)
    const [flag_cambios_guardados, set_flag_cambios_guardados] = useState(false)

    const [open, setOpen] = useState(true);

    const campos = [

        { id: 'nombre', label: 'Nombre', type: 'name', shown: true },
        { id: 'id_tipo_servicio', label: 'Tipo de servicio', type: 'select', shown: true },
        { id: 'id_edo_aut_sanitaria', label: 'Autorización sanitaria', type: 'select', shown: true },
        { id: 'nro_resolucion', label: 'Nº resolución', type: 'number', shown: true },
        { id: 'fecha_resolucion', label: 'Fecha resolución', type: 'date', shown: false },
        { id: 'id_autoridad', label: 'Autoridad que otorga', type: 'select', shown: false },
        { id: 'cantidad', label: 'Cantidad', type: 'number', shown: true },
        { id: 'ubicacion', label: 'Ubicación', type: 'text', shown: true },

    ]

    useEffect(() => {
        const baseValid = (
            aut_sanitaria !== 0 &&
            nro_resolucion !== '' &&
            fecha_resolucion !== '' &&
            tipo_servicio !== 0
        );

        const extraValid = (
            rut_proveedor !== '' &&
            nombre_proveedor !== ''
        );

        const isValid = tipo_servicio !== 2
            ? baseValid
            : baseValid && extraValid && validateRut(rut_proveedor);

        set_guardarFlag(!isValid);
    }, [
        aut_sanitaria,
        nro_resolucion,
        fecha_resolucion,
        tipo_servicio,
        rut_proveedor,
        nombre_proveedor
    ]);

    useEffect(() => {
        if (flag_mostrar) {
            setIsLoading(true)
            getServiciosMed(sessionStorage.getItem('parentIdNav'))
                .then(res => {

                    res.data.servicios_internos.map((item, index) => {

                        if (item.id === parseInt(sessionStorage.getItem('idNav'))) {
                            setTitulo(item.nombre)
                            if (item.descripcion) {
                                setDescripcion(item.descripcion)
                            }
                            setInstalacionesList(ordenarArregloAlfabeticamente(item.espacios))
                        }
                        return null

                    })
                })
                .catch(e => console.error(e))
                .finally(f => {
                    setIsLoading(false)
                })
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flag_mostrar])

    useEffect(() => {
        resetData()
        setIsLoading(true)
        const user = JSON.parse(sessionStorage.getItem("user"))

        getServiciosMed(sessionStorage.getItem('parentIdNav'))
            .then(res => {

                res.data.servicios_internos.map((item, index) => {

                    if (item.id === parseInt(sessionStorage.getItem('idNav'))) {
                        setTitulo(item.nombre)
                        if (item.descripcion) {
                            setDescripcion(item.descripcion)
                        }

                    }
                    return null

                })
            })
            .catch(e => console.error(e))
            .finally(f => {

                getServicioAutSanitaria(user.organization.id, sessionStorage.getItem('idNav'))
                    .then(res => {
                        if (res.data.length === 0) {

                        } else {
                            set_aut_sanitaria(res.data.id_autoridad ? res.data.id_autoridad : 0)
                            set_nro_resolucion(res.data.nro_resolucion ? res.data.nro_resolucion : '')
                            set_fecha_resolucion(res.data.fecha_resolucion ? res.data.fecha_resolucion : '')
                            set_tipo_servicio(res.data.tipo_servicio ? parseInt(res.data.tipo_servicio) : 0)
                            set_rut_proveedor(res.data.rut_proveedor_servicio ? res.data.rut_proveedor_servicio : '')
                            set_nombre_proveedor(res.data.nombre_proveedor_servicio ? res.data.nombre_proveedor_servicio : '')
                            setHasService(res.data.otorga_servicio ? res.data.otorga_servicio : 0)
                            set_flag_mostrar(true)
                            setOpen(true)
                        }
                    })
                    .catch(e => console.error(e))
                    .finally(f => {
                        //if (flag_mostrar) {
                        setIsLoading(false)
                        //  }

                    })
            })


        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    useEffect(() => {
        if (hasService === 0) setOpen(false);
        if (hasService === 1) setOpen(true);
    }, [hasService]);

    const resetData = () => {
        set_aut_sanitaria(0)
        set_nro_resolucion('')
        set_fecha_resolucion('')
        set_tipo_servicio(0)
        set_rut_proveedor('')
        set_nombre_proveedor('')
        setHasService(0)
        set_flag_mostrar(false)
    }

    const enviarDataAutsanitaria = () => {
        const user = JSON.parse(sessionStorage.getItem("user"))
        setIsLoading(true)
        let data = {
            otorga_servicio: 1,
            id_prestador: user.organization.id,
            id_ficha_tecnica: sessionStorage.getItem('idFicha'),
            nro_resolucion: nro_resolucion,
            id_autoridad: aut_sanitaria,
            rut_proveedor_servicio: rut_proveedor ? rut_proveedor : null,
            id_servicio_medico: sessionStorage.getItem('idNav'),
            fecha_resolucion: fecha_resolucion ? fecha_resolucion : null,
            nombre_proveedor_servicio: nombre_proveedor ? nombre_proveedor : null,
            tipo_servicio: tipo_servicio
        }
        postServicioAutSanitaria(data)
            .then(res => {

                setOpen(false)
                set_flag_cambios_guardados(true)
                toast.success("Datos de autorización sanitaria guardados con éxito")
            })
            .catch(e => console.error())
            .finally(f => {
                set_flag_mostrar(true)
            })
    }

    const deleteServicio = () => {
        const user = JSON.parse(sessionStorage.getItem("user"))
        deleteSerivioAutSanitaria(user.organization.id, sessionStorage.getItem('idNav'))
            .then(res => {
                set_aut_sanitaria(0)
                set_nro_resolucion('')
                set_fecha_resolucion('')
                set_tipo_servicio(0)
                set_rut_proveedor('')
                set_nombre_proveedor('')
                setHasService(0)
                set_flag_mostrar(false)
            })
            .catch(e => console.error(e))
            .finally(f => {

            })
    }

    return (
        <>
            {isLoading ?
                <Spinner show={isLoading} />
                :
                null

            }
            <>

                <div style={{ width: '100%', flexBasis: '100%', backgroundColor: 'white' }}>

                    <SharedTitle
                        title={titulo}
                    />
                    <Grid item xs={12} sm={12} md={12} style={{ paddingTop: 15, paddingBottom: 15, paddingLeft: 25, paddingRight: 25 }}>
                        <p>{descripcion}</p>
                    </Grid>

                    <Grid
                        container
                        item
                        xs={12}
                    >

                        <Grid
                            direction='row'
                            container
                            item
                            xs={12}
                            spacing={4}
                            style={{
                                backgroundColor: 'white',
                                paddingTop: 5,
                                borderRadius: 5,
                                paddingBottom: 5,
                                marginTop: 15,
                                margin:0
                            }}
                        >

                            <Grid
                                item
                                xs={12}
                                container
                                direction="row"
                                alignItems="center"
                                spacing={2}
                                style={{ paddingLeft: 20, paddingRight: 20 }}
                            >
                                <FormControl>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={hasService === 1}
                                                color="primary"
                                                onChange={(e) => {
                                                    const v = e.target.checked ? 1 : 0;
                                                    setHasService(v);

                                                    if (v === 0 && !guardar_flag) {
                                                        deleteServicio();
                                                    }
                                                }}
                                            />
                                        }
                                        label={
                                            <Typography style={{ fontSize: 14 }}>
                                                {"¿Prestador otorga prestaciones de " + titulo + "?"}
                                            </Typography>
                                        }
                                        labelPlacement="start"
                                    />
                                </FormControl>

                                {hasService === 1 && (
                                    <>
                                        <Typography style={{ fontSize: 14, color: "grey", marginLeft: 10 }}>
                                            <Warning style={{ fontSize: 12 }} />
                                            Debe contar con autorización sanitaria vigente
                                        </Typography>
                                        <Box flexGrow={1} />
                                        {
                                            flag_cambios_guardados ?
                                                <Typography style={{ fontSize: 14, color: "grey" }}>
                                                    <CheckBox style={{ fontSize: 12 }} /> Cambios guardados
                                                </Typography>
                                                :
                                                null
                                        }

                                    </>
                                )}
                            </Grid>



                            <Grid item xs={12} container justifyContent="flex-end" alignItems="center">

                                {hasService === 1 ? (
                                    <Grid container direction='row' justifyContent='space-between' style={{ paddingLeft: 20, paddingRight: 20 }}>
                                        <FormControl component={"fieldset"}
                                            style={{
                                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                                borderRadius: 4,
                                                padding: "16px",
                                                width: "100%"
                                            }}
                                        >
                                            <FormLabel component={"legend"}>
                                                <Typography style={{ fontSize: 14, color: 'black' }}>

                                                    Autorización sanitaria
                                                </Typography>

                                            </FormLabel>
                                            <Grid container direction='row' justifyContent='flex-end'
                                                style={{ marginTop: -25 }}
                                            >

                                                <ExpandMoreIcon
                                                    onClick={() => setOpen(v => !v)}
                                                    style={{
                                                        transition: 'transform 150ms ease',
                                                        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                                                        cursor: 'pointer'
                                                    }}
                                                />

                                            </Grid>
                                            <Collapse in={hasService === 1 && open} timeout="auto" unmountOnExit style={{ width: '100%' }}>
                                                {
                                                    hasService === 1 ?
                                                        <div >
                                                            <AsInstalacionFuncionamiento
                                                                title={"Autorización sanitaria"}
                                                                nResolucion={nro_resolucion}
                                                                fechaOtorgada={fecha_resolucion}
                                                                autoridadQueDicta={aut_sanitaria}
                                                                setNResolucion={set_nro_resolucion}
                                                                setFechaOtorgada={set_fecha_resolucion}
                                                                setAutoridadQueDicta={set_aut_sanitaria}
                                                            >


                                                                {
                                                                    hasService === 1 ?
                                                                        <Grid item xs={4} sm={4}>
                                                                            <FormControl size='small' fullWidth>
                                                                                <InputLabel
                                                                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                                                                    htmlFor="grouped-native-select"
                                                                                    style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                                                                    {"Tipo de servicio"}
                                                                                </InputLabel>
                                                                                <Select
                                                                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                                                                    native
                                                                                    label={"Tipo de servicio"}
                                                                                    id="grouped-native-select"
                                                                                    fullWidth
                                                                                    variant='outlined'
                                                                                    value={tipo_servicio}
                                                                                    onChange={(e) => {
                                                                                        set_tipo_servicio(parseInt(e.target.value))
                                                                                    }}
                                                                                >
                                                                                    {tiposAux.map((item, index) => {
                                                                                        return <option key={index} value={item.value}> {item.label}</option>
                                                                                    })}
                                                                                </Select>
                                                                            </FormControl>

                                                                        </Grid>
                                                                        :
                                                                        null
                                                                }

                                                                {
                                                                    tipo_servicio === 2 && hasService ?
                                                                        <Grid item xs={4} sm={4}>
                                                                            <AppTextInput
                                                                                InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                                                                fullWidth
                                                                                size={'small'}
                                                                                variant="outlined"
                                                                                label="Nombre Proveedor"
                                                                                value={nombre_proveedor}
                                                                                onChange={e => {
                                                                                    set_nombre_proveedor(e.target.value)
                                                                                }}
                                                                            />

                                                                        </Grid>

                                                                        :

                                                                        null

                                                                }

                                                                {
                                                                    tipo_servicio === 2 && hasService ?
                                                                        <Grid item xs={4} sm={4}>
                                                                            <AppTextInput
                                                                                InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                                                                fullWidth
                                                                                size={'small'}
                                                                                variant="outlined"
                                                                                label="RUT Proveedor"
                                                                                value={rut_proveedor}
                                                                                error={!validateRut(rut_proveedor)}
                                                                                onChange={e => {
                                                                                    let inputRut = e.target.value;
                                                                                    inputRut = inputRut.slice(0, 13);
                                                                                    const formattedRut = formatRut(inputRut);
                                                                                    set_rut_proveedor(formattedRut)
                                                                                }}
                                                                            />

                                                                        </Grid>

                                                                        :

                                                                        null

                                                                }

                                                            </AsInstalacionFuncionamiento>

                                                        </div>
                                                        :

                                                        null
                                                }
                                                <Grid
                                                    container
                                                    item
                                                    xs={12}
                                                    spacing={4}
                                                    justifyContent='flex-end'
                                                    style={{
                                                        backgroundColor: 'white',
                                                        paddingTop: 5,
                                                        borderRadius: 5,
                                                        paddingBottom: 5,
                                                        marginTop: 15,
                                                        marginBottom: 15
                                                    }}>

                                                    {
                                                        !(hasService === 1 && flag_mostrar) ?
                                                            <Grid item xs={3} sm={3} container direction='column' justifyContent='center'>
                                                                <Button
                                                                    variant='outlined'
                                                                    color='primary'
                                                                    disabled={guardar_flag}
                                                                    onClick={() => {
                                                                        enviarDataAutsanitaria()
                                                                    }}

                                                                >
                                                                    <Save style={{ marginRight: 10 }} />
                                                                    Guardar y continuar
                                                                </Button>
                                                            </Grid>
                                                            : null

                                                    }
                                                </Grid>


                                            </Collapse>
                                        </FormControl>

                                    </Grid>

                                ) : null}
                            </Grid>
                        </Grid>


                    </Grid>

                    {(instalacionesList.length > 0 && hasService === 1 && flag_mostrar

                    ) ?

                        <Grid container direction='row' justifyContent='space-between' style={{ paddingLeft: 25, paddingRight: 25 }}>
                            <FormControl component={"fieldset"}
                                style={{
                                    border: "1px solid rgba(0, 0, 0, 0.23)",
                                    borderRadius: 4,
                                    padding: "16px",
                                    width: "100%"
                                }}
                            >
                                <FormLabel component={"legend"}>
                                    <Typography style={{ fontSize: 14, color: 'black' }}>

                                        {"Servicios de "+titulo}
                                    </Typography>

                                </FormLabel>
                                <CapacidadInstaladaPropuesta
                                    espacios={instalacionesList}
                                    hasCount={true}
                                    fields={campos}
                                    setLoading={setIsLoading}
                                    datosAut={{
                                        "aut_sanitaria": aut_sanitaria,
                                        "nro_resolucion": nro_resolucion,
                                        "fecha_resolucion": fecha_resolucion
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        :
                        null
                    }
                </div>


            </>
            <CustomToast />
        </>
    )

}

export default CamasMedicina
